import isId from "../../../utils/typeGuards/isId";
import { isLearningPathIdResponseDTO } from "./LearningPathId";

export interface LearningPathIdsApi {
  learningPathId: string;
  learningPathModuleIds: string[];
  learningPathResourceIds: string[];
}

export let isLearningPathIdsResponseDTO = (
  variable: unknown
): variable is LearningPathIdsApi => {
  return (
    isLearningPathIdResponseDTO(variable) &&
    "learningPathModuleIds" in variable &&
    Array.isArray(variable.learningPathModuleIds) &&
    variable.learningPathModuleIds.reduce(
      (doArrayConsistOfIds, id: unknown) => doArrayConsistOfIds && isId(id),
      true
    ) &&
    "learningPathResourceIds" in variable &&
    Array.isArray(variable.learningPathResourceIds) &&
    variable.learningPathResourceIds.reduce(
      (doArrayConsistOfIds, id: unknown) => doArrayConsistOfIds && isId(id),
      true
    )
  );
};
